import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { BoostedJackpotWinPopupView } from './boostedJackpotWinPopupView';
import { useStore } from '../../../../../../hooks';

export const BoostedJackpotWinPopup: React.FC<{
  amountSlotRef?: any,
  congratSlotRef?: any,
  bgSpineRef?: any,
  buttonSlotRef?: any,
}> = observer(({
  amountSlotRef,
  congratSlotRef,
  bgSpineRef,
  buttonSlotRef,
}) => {
  const { boostedJackpotStore } = useStore();
  const {
    spinWheelWinAmount,
    isBoostedJackpotWinPopup,
    setIsWheel,
    setSpinWheelWinAmount,
    setIsBoostedJackpotWinPopup,
  } = boostedJackpotStore;

  if (!isBoostedJackpotWinPopup) return null;

  return (
    <Container
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      name="WinPopupWrapper">
      <BoostedJackpotWinPopupView
        setIsWheel={setIsWheel}
        spinWheelWinAmount={spinWheelWinAmount}
        setSpinWheelWinAmount={setSpinWheelWinAmount}
        setIsBoostedJackpotWinPopup={setIsBoostedJackpotWinPopup}
        amountSlotRef={amountSlotRef}
        congratSlotRef={congratSlotRef}
        bgSpineRef={bgSpineRef}
        buttonSlotRef={buttonSlotRef}
      />
    </Container>
  );
});
